import ar from './ar.json';
import en from './en.json';

/**
 * The Violations module's catalogue, registered from `app.config.tsx` under the
 * `violations` namespace — `shared/i18n` never imports a module (W2).
 *
 * Separate from `moderation`'s: reports and AI violations are two queues with
 * two permissions and two vocabularies, and a namespace reaching into another
 * module's is the i18n spelling of the import W2 forbids.
 */
export const violationsCatalogs = { ar, en };
